var map = {
	"./AlphabetGoogle 2.jpg": 61454,
	"./AlphabetGoogle.jpg": 99892,
	"./Amazon 2.png": 72598,
	"./Amazon.png": 99420,
	"./BenjaminGraham 2.jpg": 66596,
	"./BenjaminGraham.jpg": 41438,
	"./BerkShire 2.jpg": 86923,
	"./BerkShire.jpg": 82777,
	"./CharlieMunger 2.jpg": 71400,
	"./CharlieMunger.jpg": 15682,
	"./ConstellationSoftware 2.jpg": 85458,
	"./ConstellationSoftware.jpg": 57592,
	"./Exor 2.jpg": 45794,
	"./Exor.jpg": 37864,
	"./Fairfax 2.jpg": 81147,
	"./Fairfax.jpg": 4553,
	"./JamieDimon 2.jpg": 90529,
	"./JamieDimon.jpg": 39427,
	"./JohnMaynardKeynes 2.jpg": 97026,
	"./JohnMaynardKeynes.jpg": 22216,
	"./LiLu 2.jpg": 77630,
	"./LiLu.jpg": 84260,
	"./Markel 2.jpg": 15286,
	"./Markel.jpg": 53468,
	"./NickSleep 2.jpg": 33566,
	"./NickSleep.jpg": 5572,
	"./PeterLynch 2.jpg": 63424,
	"./PeterLynch.jpg": 89082,
	"./WalterSchloss 2.jpg": 46988,
	"./WalterSchloss.jpg": 10854,
	"./WarrenBuffett 2.jpg": 35163,
	"./WarrenBuffett.jpg": 20105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68742;